import script from "./GodApeQuest.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuest.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuest.vue?vue&type=style&index=0&id=3fbb49be&lang=scss"

const __exports__ = script;

export default __exports__